import React, { useState, useEffect } from 'react';
import Login from './Login';
import STSForm from './STSForm';

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(null); // null: loading, true/false: resultado

  useEffect(() => {
    fetch('/core/check-session.php', { credentials: 'include' })
      .then(res => res.json())
      .then(data => setIsLoggedIn(data.loggedIn))
      .catch(() => setIsLoggedIn(false));
  }, []);

  return (
    <>
      {isLoggedIn ? <STSForm /> : <Login onLogin={() => setIsLoggedIn(true)} />}
    </>
  );
}

export default App;
